import { render, staticRenderFns } from "./emailCampaignsListGenerator.vue?vue&type=template&id=bda72472"
import script from "./emailCampaignsListGenerator.vue?vue&type=script&lang=js"
export * from "./emailCampaignsListGenerator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports